import React, {useState} from 'react';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {UserPermission} from 'types';

import {Root, Pill as StyledPill} from './styled';

export enum PillVariant {
    text,
    button,
}

export interface PillItem {
    label: string;
    cb?: Function;
    permissions?: UserPermission[];
}

interface Props {
    startedIndex?: number;
    forceIndex?: number;
    onChange?(pill: PillItem): any;
    items: PillItem[];
    variant?: PillVariant;
    className?: string;
}

export function Pills({
    startedIndex,
    onChange,
    items,
    variant = PillVariant.text,
    forceIndex,
    className,
}: Props) {
    const [currentIndex, setCurrentIndex] = useState(startedIndex || 0);

    const handleChange = (pill: PillItem, index: number) => {
        setCurrentIndex(index);
        if (typeof items[index].cb === 'function') {
            // @ts-ignore
            items[index].cb();
        }
        if (onChange) {
            onChange(pill);
        }
    };

    return (
        <Root className={className}>
            {items.map((pill, i) => {
                const isActive = forceIndex ? forceIndex === i : currentIndex === i;
                return (
                    <PermissionAccess permissions={pill.permissions}>
                        <StyledPill
                            className={isActive ? 'active' : 'not-active'}
                            onClick={() => handleChange(pill, i)}
                            isActive={isActive}
                            key={i}
                            variant={variant}
                        >
                            {pill.label}
                        </StyledPill>
                    </PermissionAccess>
                );
            })}
        </Root>
    );
}

export const Pill = StyledPill;
